import { useEffect } from 'react';
import type { TsoPlatformIds } from 'src/apis/monolith/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';

export function useOperatorPlatformId(uuid: string) {
  const tso = useAxios(
    (axios, baseConfig, uuid: string) =>
      axios.request<TsoPlatformIds>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/tso/platform-ids/${uuid}`,
      }),
    {
      neededOnPageLoad: true,
      onError: (err) => {
        if (isServerError(err, 404)) {
          return err;
        } else {
          throw err;
        }
      },
    }
  );

  useEffect(() => {
    tso.execute(uuid);
    // oxlint-disable-next-line exhaustive-deps
  }, [uuid]);

  return tso;
}

export type TsoPlatformIdsRequest = ReturnType<typeof useOperatorPlatformId>;
